import { FormType } from '../../../form-types';

export const edBelugaMonthly: FormType = {
  name: 'ED Monthly Visit',
  questions: [
    {
      key: 'edMonthly_sexAtBirth',
      next: {
        condition: { 'edMonthly_sexAtBirth.edMonthly_sexAtBirth_male': true },
        key: 'generic_heightWeight2025',
        els: 'edMonthly_ineligible'
      }
    },
    'generic_heightWeight2025',
    {
      key: 'edMonthly_healthChanges',
      next: {
        condition: {
          'edMonthly_healthChanges.edMonthly_healthChanges_yes': true
        },
        key: 'edMonthly_healthChanges_details',
        els: 'edMonthly_medicationStatus'
      }
    },
    'edMonthly_healthChanges_details',
    {
      key: 'edMonthly_medicationStatus',
      next: {
        condition: {
          'edMonthly_medicationStatus.edMonthly_medicationStatus_notWell': true
        },
        key: 'edMonthly_medicationStatus_details',
        els: 'edMonthly_sideEffects'
      }
    },
    'edMonthly_medicationStatus_details',
    {
      key: 'edMonthly_sideEffects',
      next: {
        condition: {
          'edMonthly_sideEffects.edMonthly_sideEffects_yes': true
        },
        key: 'edMonthly_sideEffects_details',
        els: 'edMonthly_otherInformation'
      }
    },
    'edMonthly_sideEffects_details',
    'edMonthly_otherInformation',
    {
      key: 'edMonthly_consent',
      next: {
        condition: {
          'edMonthly_consent.edMonthly_consent_agree': true
        },
        key: 'edMonthly_complete',
        els: 'edMonthly_didNotConsent'
      }
    },
    'edMonthly_ineligible',
    'edMonthly_didNotConsent',
    'edMonthly_complete'
  ]
};
